import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { StorageService } from '../../core/storage/storageService';

@Component({
  selector: 'app-master-layout',
  templateUrl: './master-layout.component.html',
  standalone: false
})
export class MasterLayoutComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('stickyChrome', { static: true })
  stickyChrome!: ElementRef<HTMLElement>;

  showNotes: boolean = true;
  hideSideNav: boolean = false;
  pageWidth: 'standard' | 'full' = 'standard';

  private routerSub: Subscription | undefined;
  private stickyChromeObserver: ResizeObserver | undefined;

  constructor(
    public storage: StorageService,
    public router: Router,
  ) {
    //storage.setShowSupportInfo(storage.getSelectedLocation() != undefined);
    // this.showNotes =
    //   storage.getShowSupportInfo() &&
    //   storage.getCurrentUser().originalRole != 'portal.merchant';
    this.hideSideNav = this.router.url.includes('payable-invoice');
  }

  ngOnInit() {
    this.updatePageWidth();
    this.routerSub = this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe(() => this.updatePageWidth());
  }

  ngAfterViewInit() {
    const chrome = this.stickyChrome.nativeElement;
    this.updateStickyChromeHeight(chrome.offsetHeight);

    this.stickyChromeObserver = new ResizeObserver(() => {
      this.updateStickyChromeHeight(chrome.offsetHeight);
    });
    this.stickyChromeObserver.observe(chrome);
  }

  ngOnDestroy() {
    this.routerSub?.unsubscribe();
    this.stickyChromeObserver?.disconnect();
    document.documentElement.style.removeProperty('--app-sticky-chrome-height');
  }

  private updateStickyChromeHeight(height: number): void {
    document.documentElement.style.setProperty(
      '--app-sticky-chrome-height',
      `${Math.ceil(height)}px`,
    );
  }

  private updatePageWidth(): void {
    let pageWidth: 'standard' | 'full' = 'standard';
    let current: ActivatedRoute | null = this.router.routerState.root;

    while (current) {
      const value = current.snapshot?.data?.['pageWidth'];
      if (value === 'full') {
        pageWidth = 'full';
      } else if (value === 'standard' || value === 'comfortable') {
        pageWidth = 'standard';
      }

      current =
        current.children.find((child) => child.outlet === 'primary') ??
        current.firstChild;
    }

    this.pageWidth = pageWidth;
  }
}
